// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5d4af9c6","453":"c4b6f04e","732":"d22eb903"}[chunkId] + ".chunk.js";
};